import { useAtomValue } from 'jotai';
import { CtaForm } from '@pairy/sheard/types';

import MessageBoxLayer from '../../../@common/Layer/MessageBoxLayer';
import { MessageBoxItemType } from '../../../PdfViewer/index.types';
import MobileHyperLinkLayer from '../../../@common/Layer/HyperLinkLayer/Mobile/index';
import useHandleResizedImage from '../../../../hooks/useHandleResizedImage';
import { currentPageAtom } from '../../../../store/index.atom';
import { BulkFileType } from '../../../../types/file';

interface Props {
  isPreview?: boolean;
  ctaForm?: CtaForm;
  thumbnails: BulkFileType['thumbnails'];
  messageBoxItems?: MessageBoxItemType[];
  isFormSubmitted?: boolean;
}

const AnnotationLayer = ({
  ctaForm,
  isPreview = false,
  thumbnails,
  messageBoxItems,
  isFormSubmitted,
}: Props) => {
  const currentPage = useAtomValue(currentPageAtom);
  const blindMode = ctaForm?.blind;

  const { hyperlink, originalHeight, originalWidth } =
    thumbnails[currentPage - 1];

  const { resizedImageSize } = useHandleResizedImage({
    originalHeight,
    originalWidth,
  });

  const getFormNotSubmitPage = (moveTargetPage: number) => {
    if (
      !isFormSubmitted &&
      blindMode === 'startFrom' &&
      ctaForm?.page &&
      moveTargetPage >= ctaForm?.page
    ) {
      return ctaForm.page;
    }
    return null;
  };

  return (
    <>
      <MessageBoxLayer
        resizedImageSize={resizedImageSize}
        isPreview={isPreview}
        messageBoxItems={messageBoxItems}
        getFormNotSubmitPage={getFormNotSubmitPage}
        size={'sm'}
      />
      <MobileHyperLinkLayer
        hyperlinkList={hyperlink}
        resizedImageSize={resizedImageSize}
        isPreview={isPreview}
        getFormNotSubmitPage={getFormNotSubmitPage}
      />
    </>
  );
};

export default AnnotationLayer;
